"use strict";
exports.__esModule = true;
exports.TransitionTypeList = exports.TransitionTypeListOther = exports.TransitionTypeListUnderAge3 = exports.TransitionTypeListAtAge3 = void 0;
var tslib_1 = require("tslib");
exports.TransitionTypeListAtAge3 = [
    'Eligible for PartB/Special Education',
    'Eligible for PartB/Special Education: Parents declined',
    'Not eligible for Part B: Exited to other program',
    'Not eligible for Part B: Exited with no referral',
    'Part B eligibility not determined',
];
exports.TransitionTypeListUnderAge3 = [
    'Deceased',
    'Moved out of state',
    'Other: Attempts to contact or locate unsuccessful',
    'Parent choice: Not typically developing',
    'Parent choice: Typically developing',
];
exports.TransitionTypeListOther = [
    'Child exited program without a completed IFSP',
];
exports.TransitionTypeList = (0, tslib_1.__spreadArray)((0, tslib_1.__spreadArray)((0, tslib_1.__spreadArray)([], (0, tslib_1.__read)(exports.TransitionTypeListOther), false), (0, tslib_1.__read)(exports.TransitionTypeListUnderAge3), false), (0, tslib_1.__read)(exports.TransitionTypeListAtAge3), false);
//# sourceMappingURL=index.js.map